
export const tankstellen =[
  {
    "id": "e2fc30d5-dfd7-43e8-b61d-16ba4cb0fc01",
    "name": "TOTAL Berlin",
    "brand": "TOTAL",
    "street": "Blockdammweg 6",
    "house_number": "",
    "post_code": 10317,
    "place": "Berlin",
    "lat": 52.48291,
    "lng": 13.502177,
    "isOpen": true
  },
  {
    "id": "c25b41ba-fb14-4126-9820-67c63956629c",
    "name": "TOTAL Berlin",
    "brand": "TOTAL",
    "street": "Britzer Damm 60-62",
    "house_number": "",
    "post_code": 12347,
    "place": "Berlin",
    "lat": 52.457048,
    "lng": 13.436356,
    "isOpen": true
  },
  {
    "id": "cba00de3-9841-49ce-943c-0bcded76ba18",
    "name": "TOTAL Berlin",
    "brand": "TOTAL",
    "street": "Chausseestr. 61-62",
    "house_number": "",
    "post_code": 10115,
    "place": "Berlin",
    "lat": 52.537242,
    "lng": 13.375376,
    "isOpen": true
  },
  {
    "id": "8a7a3916-0deb-46ba-bef9-4531c0cb1c7c",
    "name": "TOTAL Berlin",
    "brand": "TOTAL",
    "street": "Heerstr. 35-37",
    "house_number": "",
    "post_code": 14055,
    "place": "Berlin",
    "lat": 52.508358,
    "lng": 13.260575,
    "isOpen": true
  },
  {
    "id": "b3060ae1-10ad-4229-b2db-096372950f51",
    "name": "TOTAL Berlin",
    "brand": "TOTAL",
    "street": "Heidestr 18",
    "house_number": "",
    "post_code": 10557,
    "place": "Berlin",
    "lat": 52.534217,
    "lng": 13.365195,
    "isOpen": true
  },
  {
    "id": "4429a7d9-fb2d-4c29-8cfe-2ca90323f9f8",
    "name": "TOTAL Berlin",
    "brand": "TOTAL",
    "street": "Holzmarktstr. 36-42",
    "house_number": "",
    "post_code": 10243,
    "place": "Berlin",
    "lat": 52.511399,
    "lng": 13.428477,
    "isOpen": true
  },
  {
    "id": "5e2048bb-5930-473d-a1eb-98b56934286b",
    "name": "TOTAL Berlin",
    "brand": "TOTAL",
    "street": "Rhinstrasse 52",
    "house_number": "",
    "post_code": 12681,
    "place": "Berlin",
    "lat": 52.518378,
    "lng": 13.520045,
    "isOpen": true
  },
  {
    "id": "474e5046-deaf-4f9b-9a32-9797b778f047",
    "name": "TOTAL Berlin",
    "brand": "TOTAL",
    "street": "Margarete-Sommer-Str. 2",
    "house_number": "",
    "post_code": 10407,
    "place": "Berlin",
    "lat": 52.530831,
    "lng": 13.440946,
    "isOpen": true
  },
  {
    "id": "94e70fc4-b22f-4e5a-877f-bc1082cdae81",
    "name": "TOTAL Berlin",
    "brand": "TOTAL",
    "street": "Prenzlauer Allee 1-4",
    "house_number": "",
    "post_code": 10405,
    "place": "Berlin",
    "lat": 52.528899,
    "lng": 13.41808,
    "isOpen": true
  },
  {
    "id": "ade023de-dad0-40e7-bcc3-0a25e9a85c77",
    "name": "TOTAL Berlin",
    "brand": "TOTAL",
    "street": "Rhinstrasse 175",
    "house_number": "",
    "post_code": 13053,
    "place": "Berlin",
    "lat": 52.536691,
    "lng": 13.51541,
    "isOpen": true
  },
  {
    "id": "5f379d51-e2c8-47d8-bf3e-807e7f3737a7",
    "name": "TOTAL Berlin",
    "brand": "TOTAL",
    "street": "Landsberger Allee 376",
    "house_number": "",
    "post_code": 12681,
    "place": "Berlin",
    "lat": 52.535395,
    "lng": 13.522849,
    "isOpen": true
  },
  {
    "id": "95bfae72-560c-431f-82a1-6cf73a1ef456",
    "name": "TOTAL Berlin",
    "brand": "TOTAL",
    "street": "Spaethstr. 158",
    "house_number": "",
    "post_code": 12359,
    "place": "Berlin",
    "lat": 52.453355,
    "lng": 13.45764,
    "isOpen": true
  },
  {
    "id": "38e0e779-b0f1-46ae-a35b-09f8e37024a1",
    "name": "TOTAL Berlin",
    "brand": "TOTAL",
    "street": "Storkower Str. 174",
    "house_number": "",
    "post_code": 10369,
    "place": "Berlin",
    "lat": 52.52744,
    "lng": 13.457798,
    "isOpen": true
  },
  {
    "id": "5b24dba1-c64c-4480-9943-ac3f23e43912",
    "name": "TOTAL Berlin",
    "brand": "TOTAL",
    "street": "Tempelhofer Ufer 33-35",
    "house_number": "",
    "post_code": 10963,
    "place": "Berlin",
    "lat": 52.500478,
    "lng": 13.376696,
    "isOpen": true
  },
  {
    "id": "403be9a4-04fb-4bd0-9b52-ca1cfb8490c5",
    "name": "TOTAL Berlin",
    "brand": "TOTAL",
    "street": "Adlergestell 543",
    "house_number": "",
    "post_code": 12527,
    "place": "Berlin",
    "lat": 52.414343,
    "lng": 13.572973,
    "isOpen": true
  },
  {
    "id": "51863198-2987-48b8-aa2e-dd949bc403dc",
    "name": "TOTAL Berlin",
    "brand": "TOTAL",
    "street": "Bulgarische Str. 9",
    "house_number": "",
    "post_code": 12435,
    "place": "Berlin",
    "lat": 52.483773,
    "lng": 13.478669,
    "isOpen": true
  },
  {
    "id": "73f34ee9-64ab-4009-a092-575ce13ce326",
    "name": "TOTAL Berlin",
    "brand": "TOTAL",
    "street": "Schoeneberger Str 17",
    "house_number": "",
    "post_code": 12103,
    "place": "Berlin",
    "lat": 52.470148,
    "lng": 13.371984,
    "isOpen": true
  },
  {
    "id": "44f549e9-3bc7-4289-8e1e-c47df3e93cca",
    "name": "TOTAL Berlin",
    "brand": "TOTAL",
    "street": "Adlergestell 623",
    "house_number": "",
    "post_code": 12527,
    "place": "Berlin",
    "lat": 52.387774,
    "lng": 13.630654,
    "isOpen": true
  },
  {
    "id": "a0f35e83-2d97-4bfb-b90e-f068fe8c73e1",
    "name": "TOTAL Berlin",
    "brand": "TOTAL",
    "street": "Indira-Gandhi-Str. 106-109",
    "house_number": "",
    "post_code": 13053,
    "place": "Berlin",
    "lat": 52.547499,
    "lng": 13.46808,
    "isOpen": true
  }
]

 












